<template>
	<div>
		<HeaderLogin />
		<router-view />
	</div>
</template>

<script>
import { HeaderLogin } from "./components";
export default {
	components: {
		HeaderLogin,
	},
};
</script>

<style scoped></style>
